import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type ModalDialog } from '@/scripts/theme/modal-dialog'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class ModalOpener extends UcoastEl {
	static htmlSelector = 'modal-opener'
	constructor() {
		super()

		const button: HTMLElement | null = this.querySelector(
			'button,.modal-opener'
		)
		if (!button) return
		button.addEventListener('click', () => {
			const modalSelector = this.getAttribute('data-modal')
			if (!modalSelector) return
			const variantId =
				this.getAttribute('data-upsell-from-variant') ?? undefined
			const modal = q.os<ModalDialog>(modalSelector)
			if (modal) modal.show(button, variantId)
		})
	}
}
